import { Box, Button, Typography } from "@mui/material";
import React, { useCallback } from "react";
import { useMutation } from "react-query";
import { SaveButton } from "../../../components/SaveButton";
import { useAuth } from "../../../hooks/useAuth";
import { useToast } from "../../../hooks/useToast";
import { putOnboard } from "../../../services/company";
import endImage from "../../../assets/initialSettings/endScreen/endImage.svg";
import { useStyles } from "./styles";
import { isLocalhost, isReleaseEnvironment } from "../../../utils/constants";

interface WhatsappProps {
  advance: (num: number) => void;
}

export function EndScreen(props: WhatsappProps) {
  const toast = useToast();
  const { token } = useAuth();
  const styles = useStyles();

  const handleGoToDsMktV2 = useCallback(
    (option: string) => {
      const alias = isLocalhost
        ? "https://tech.datasales.info"
        : isReleaseEnvironment
        ? "https://qa.datasales.info"
        : "https://app.dsmarketing.com.br";

      const urlDsV2 = ` ${alias}/sign-as-user/${token}?shortToRedirect=${option}`;

      window.location.assign(urlDsV2);
    },
    [token]
  );

  const postIntanciaUpdate = useMutation(
    async () => {
      const onboard = { onboard: 1 };

      const response = await putOnboard(onboard);

      return response;
    },
    {
      onSuccess: async () => {
        toast.show("Configurações salvas com sucesso", { severity: "success" });

        handleGoToDsMktV2("home");
      },
      onError: () => {
        toast.show("Falha ao salvar suas configurações!", {
          severity: "error",
        });
      },
    }
  );

  const onSubmit = async () => {
    try {
      await postIntanciaUpdate.mutateAsync();
    } catch (err) {
      console.log({ err });
    }
  };

  return (
    <Box className={styles.boxCentral}>
      <Box>
        <Box className={styles.boxImg}>
          <img src={endImage} alt="" />
        </Box>
        <Typography className={styles.titulo}>Tudo certo!</Typography>
        <Typography className={styles.subTitulo}>
          Agora você já pode começa a começar a fazer suas propagandas. Caso
          você tenha dúvidas, você pode sempre chamar nossa equipe de suporte.
          Nosso horário de atendimento é de segunda a sexta das 8h às 21h, e aos
          sábados das 8h às 12h.
        </Typography>
        <Box className={styles.boxButtons}>
          <Button
            className={styles.buttonVoltar}
            onClick={() => {
              props.advance(2);
            }}
          >
            Voltar para configurações
          </Button>
          <SaveButton
            titulo="Continuar"
            isSubmitting={postIntanciaUpdate.isLoading}
            size="large"
            onSave={() => {
              onSubmit();
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
